import Vue from "vue";
import Router from "vue-router";

// Containers
import Full from "@/containers/Full";

// Views
import Dashboard from "@/views/Dashboard";
import Login from "@/views/Login";
import ClinicalActivity from "@/views/Reports/ClinicalActivity";
import ResetPassword from "@/views/ResetPassword";
import ForgetPassword from "@/views/ForgetPassword";
import AllOrders from "@/views/Orders/AllOrders";
import PrescriberOrders from "@/views/Orders/PrescriberOrders";
import ChangePin from "@/views/Shared/ChangePin";
import ChangePassword from "@/views/Shared/ChangePassword";
import TwoFactorAuthentication from "@/views/Shared/TwoFactorAuthentication";
import Doctors from "@/views/Doctors/Doctors";
import GPs from "@/views/GPs/GPs";
import Patients from "@/views/Patients/Patients";
import CallbackRequests from "@/views/Callbacks/CallbackRequests";
import Patient from "@/views/Patients/Patient";
import ConsultationInviteSent from "@/views/Patients/ConsultationInviteSent";
import Pharmacies from "@/views/Pharmacies/Pharmacies";
import Appointments from "@/views/Doctors/Appointments";
import Pharmacy from "@/views/Pharmacies/Pharmacy";
import ConfirmDeliveryOrders from "@/views/Orders/ConfirmDeliveryOrders";
import Order from "@/views/Orders/Order";
import ConfirmDelivery from "@/views/Orders/ConfirmDelivery";
import ChangeDeliveryOrders from "@/views/Orders/ChangeDeliveryOrders";
import ChangeDelivery from "@/views/Orders/ChangeDelivery";
import RejectedByPharmacyOrders from "@/views/Orders/RejectedByPharmacyOrders";
import RejectedByPharmacy from "@/views/Orders/RejectedByPharmacy";
import PaymentFailedOrders from "@/views/Orders/PaymentFailedOrders";
import PaymentFailed from "@/views/Orders/PaymentFailed";
import AwaitingAdditionalPaymentOrders from "@/views/Orders/AwaitingAdditionalPaymentOrders";
import Formulary from "@/views/Formulary/Formulary";
import FormFormulary from "@/views/Formulary/FormFormulary";
import Coupons from "@/views/Coupons/Coupons";
import Enterprises from "@/views/Enterprises/Enterprises";
import Platforms from "@/views/Platforms/Platforms";
import Platform from "@/views/Platforms/Platform";
import Pricing from "@/views/Pricing/Pricing";
import Subscriptions from "@/views/Subscriptions/Subscriptions";
import Packages from "@/views/Packages/Packages";
import GPNotes from "@/views/GPNotes/GPNotes";
import PageNotFound from "@/views/PageNotFound";
import Admins from "@/views/Admins/Admins";
import Prescribers from "@/views/Prescribers/Prescribers";
import Prescriber from "@/views/Prescribers/Prescriber";
import RepeatOrders from "../views/Orders/RepeatOrders.vue";
import { onboardingTrackingRoutes } from "@/views/OnboardingTracking";

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/login",
      name: "Home",
      component: Full,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "change-pin/:userType/:userId",
          name: "Change PIN",
          props: true,
          component: ChangePin,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "change-password",
          name: "Update password",
          component: ChangePassword,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "two-factor-auth",
          name: "Two Factor Authentication",
          component: TwoFactorAuthentication,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "change-password/:userType/:userId",
          name: "Change Password",
          props: true,
          component: ChangePassword,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "doctors",
          name: "Doctors",
          component: Doctors,
          meta: { description: "", requiresAuth: true },
        },
        {
            path: "gps",
            name: "GPs",
            component: GPs,
            meta: { description: "", requiresAuth: true },
        },
        {
          // Phone call-back queue (requests from app.thegpservice.co.uk/phone-consultation)
          path: "call-backs",
          name: "CallbackRequests",
          component: CallbackRequests,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "patients",
          name: "Patients",
          component: Patients,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "patient/:patientId",
          name: "Patient",
          component: Patient,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "patient/:patientId/consultation-invite-sent",
          name: "ConsultationInviteSent",
          component: ConsultationInviteSent,
          props: true,
          meta: { label: "Payment link sent", description: "", requiresAuth: true },
        },
        {
          path: "pharmacies",
          name: "Pharmacies",
          component: Pharmacies,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "appointments",
          name: "Appointments",
          component: Appointments,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "pharmacy/:pharmacyId",
          name: "Pharmacy",
          component: Pharmacy,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/all",
          name: "All orders",
          props: {
            types: ["FORM", "BOOKING", "TRAVEL", "PRESCRIPTION_ONLY", 'CHAT_ASSESSMENT'],
          },
          component: AllOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/repeat-orders",
          name: "Repeat orders",
          component: RepeatOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/gps",
          name: "GPS orders",
          props: {
            types: ["FORM", "BOOKING", "TRAVEL"],
          },
          component: AllOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/docnow",
          name: "DocNow orders",
          props: {
            types: ["CHAT_ASSESSMENT"],
          },
          component: AllOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/prescriber",
          name: "Prescriber orders",
          props: true,
          component: PrescriberOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/waiting-for-admin",
          name: "Orders - Awaiting for Admin",
          props: true,
          component: ConfirmDeliveryOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/change-delivery",
          name: "Orders - Change delivery details",
          props: true,
          component: ChangeDeliveryOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/rejected-by-pharmacy",
          name: "Orders - Rejected by pharmacy",
          props: true,
          component: RejectedByPharmacyOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "order/rejected-by-pharmacy/:orderId",
          name: "Rejected by pharmacy",
          component: RejectedByPharmacy,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/payment-failed",
          name: "Orders - Payment Faileds",
          props: true,
          component: PaymentFailedOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "orders/additional-payments",
          name: "Orders - Awaiting Additional Payments",
          props: true,
          component: AwaitingAdditionalPaymentOrders,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "order/payment-failed/:orderId",
          name: "Payment Failed",
          component: PaymentFailed,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "order/:orderId",
          name: "Order",
          component: Order,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "order/confirm-delivery/:orderId",
          name: "Confirm delivery details",
          component: ConfirmDelivery,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "order/change-delivery/:orderId",
          name: "Change delivery details",
          component: ChangeDelivery,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "gp-notes/:orderId?",
          name: "GP Notes",
          props: true,
          component: GPNotes,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "formulary",
          name: "Formulary",
          props: true,
          component: Formulary,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "form-formulary",
          name: "FormFormulary",
          props: true,
          component: FormFormulary,
          meta: { label: "Form formulary", description: "", requiresAuth: true },
        },
        {
          path: "coupons",
          name: "Coupons",
          props: true,
          component: Coupons,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "enterprises",
          name: "Enterprises",
          props: true,
          component: Enterprises,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "platforms",
          name: "Platforms",
          props: true,
          component: Platforms,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "platform/:platformId",
          name: "Platform",
          component: Platform,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "pricing",
          name: "Pricing",
          component: Pricing,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "subscriptions",
          name: "Subscriptions",
          props: true,
          component: Subscriptions,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "packages",
          name: "Packages",
          props: true,
          component: Packages,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "admins",
          name: "Admins",
          component: Admins,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "prescribers",
          name: "Prescribers",
          component: Prescribers,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "prescriber/:prescriberId",
          name: "Prescriber",
          component: Prescriber,
          meta: { description: "", requiresAuth: true },
        },
        {
          path: "reports/clinical-activity",
          name: "Clinical Activity",
          component: ClinicalActivity,
          meta: { description: "", requiresAuth: true },
        },
        ...onboardingTrackingRoutes,
      ],
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/reset-password",
      name: "Reset Password",
      component: ResetPassword,
    },
    {
      path: "/forget-password",
      name: "Forget",
      component: ForgetPassword,
    },
    {
      path: "/page-not-found",
      name: "404 - Page not found",
      component: PageNotFound,
    },
    { path: "*", component: PageNotFound },
  ],
});
